import React, { useMemo } from 'react';
import { Box, BoxProps } from '@chakra-ui/layout';
import { Controller } from 'react-hook-form';
import SearchableDropdown from './SearchableDropdown';

type Option = Record<string | number, string | number>;

interface SelectProps {
  options: Option[];
  valueLabelOptions?: [keyof Option, keyof Option];
  fieldName: string;
  control: any;
  placeholder?: string;
  defaultValue: string | number;
  isDisabled?: boolean;
  onDependentFieldAndStateUpdate?: () => void;
  isInvalid: boolean;
  styleProps?: any;
}

const SearchableDropdownFormControl = ({
  options,
  valueLabelOptions = ['value', 'label'],
  isDisabled,
  fieldName,
  control,
  placeholder,
  defaultValue,
  onDependentFieldAndStateUpdate,
  isInvalid,
  styleProps,
  ...style
}: SelectProps & React.CSSProperties & BoxProps) => {
  /* Transform select options to value-label format */
  const selectOptions = useMemo(
    () =>
      [...options].map((obj) => ({
        value: obj?.[valueLabelOptions[0] as string | number],
        label: obj?.[valueLabelOptions[1] as string | number],
      })),
    [options, valueLabelOptions]
  );

  return (
    <Controller
      control={control}
      name={fieldName}
      defaultValue={defaultValue}
      render={({ field: { value, onChange } }) => {
        return (
          <Box {...style}>
            <SearchableDropdown
              isInvalid={isInvalid}
              placeholder={placeholder}
              options={selectOptions}
              value={value}
              onChange={(newValue) => {
                onChange(newValue);
                //Change other dependencies if any
                //e.g: when manufacturer is selected, clear model value
                onDependentFieldAndStateUpdate && onDependentFieldAndStateUpdate();
              }}
              isDisabled={isDisabled}
              styleProps={styleProps}
            />
          </Box>
        );
      }}
    />
  );
};

export default SearchableDropdownFormControl;
